export default __webpack_public_path__ + "static/media/demo-slider.df090755.svg";